import React from 'react';

import { BILLING_FREQUENCY_OPTIONS } from '../../constants/BillingFrequencyConstants';
import { MemberFeeDTO } from '../../services/apiClient';
import { renderBooleanBadge } from '../../utils/displayUtils';
import Table from '../common/Table';

interface MemberFeeTableProps {
  data: MemberFeeDTO[];
  handleEdit: (row: MemberFeeDTO) => void;
  handleDelete: (row: MemberFeeDTO) => void;
  isLoading: boolean;
}

const billingFrequencyLabel = (id?: string) =>
  BILLING_FREQUENCY_OPTIONS.find((o) => o.value === id)?.label || '';

const MemberFeeTable: React.FC<MemberFeeTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  isLoading,
}) => (
  <Table
    columns={[
      {
        label: 'Amount',
        key: 'amount',
        format: (_value: any, row: MemberFeeDTO) =>
          `${row.currency || ''} ${row.amount ?? ''}`,
      },
      {
        label: 'Billing Frequency',
        key: 'billingFrequencyId',
        format: (value: string) => billingFrequencyLabel(value),
      },
      { label: 'Stripe Price Id', key: 'stripePriceId' },
      {
        label: 'Is Active',
        key: 'isActive',
        render: (row: MemberFeeDTO) =>
          renderBooleanBadge(row.isActive ?? false),
      },
    ]}
    data={data}
    actions={{
      onEdit: handleEdit,
      onDelete: handleDelete,
    }}
    allowPaging={false}
    isLoading={isLoading}
    noDataMessage="No fees added yet"
  />
);

export default MemberFeeTable;
